import { createContext, ReactNode, useState } from 'react';

import { PlatformConversationCreateMode } from '@cloudquery/api-platform';

export interface AiContextType {
  mode: PlatformConversationCreateMode;
  setMode: (mode: PlatformConversationCreateMode) => void;
}

export const AiChatContext = createContext<AiContextType>({
  mode: 'sql',
  setMode: () => {},
});

export function AiChatContextProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<PlatformConversationCreateMode>('sql');

  return <AiChatContext.Provider value={{ mode, setMode }}>{children}</AiChatContext.Provider>;
}
